import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import EditOwnerModel from "../../Components/Owners/EditOwnerModel";
import ViewDetailModel from "../../Components/Owners/ViewDetail";
import SideModal from "../../Components/SideModal";
import FilterModal from "../../Components/FilterModals/FilterModal";
import Table from "../../Components/Owners/NewOwnerTable";

const NewOwners = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [fetchData, setFetchData] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("mobile");
  const [editUser, setEditUser] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [advancedFilter, setAdvancedFilter] = useState("");
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD"),
  );
  const { t } = useTranslation();

  const initialValues = {
    name: "",
    payuKey: "",
    payuMid: "",
    email: "",
    clintId: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("filterType", filter);
    body.append("filterValue", filterValue);
    if (advancedFilter.startsWith("MODE_")) {
      body.append("filterType", "paymentMode");
      body.append("filterValue", advancedFilter.replace("MODE_", ""));
    }
    // body.append("startDate", startDate);
    // body.append("advancedFilter", advancedFilter);
    // body.append("endDate", endDate);

    return await axios.post(`${Config.apiUrl}/getnewowners`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getOwnersSuccess = (res) => {
    if (res.data.status === "NOK" || res.data.data === false) {
      error = true;
    } else setFetchData(res.data.data);
  };

  const getOwnersError = (res) => {};

  const {
    isLoading: isLoadings,
    mutate: getOwnersMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getOwnersSuccess,
    onError: getOwnersError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getOwnersMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate, advancedFilter]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getOwnersMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
    if (advancedFilter.startsWith("MODE_")) {
      setAdvancedFilter("");
    }
  };


  //------- Edit Owner Single Entry -------
  const EditOwnerFunction = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("name", values.name);
    body.append("acquiredBy", values.acquiredBy);
    body.append("holdOutBalance", values.holdOutBalance);
    body.append("email", values.email);
    body.append("mobile", values.mobile);
    body.append("status", values.status);
    body.append("panNumber", values.panNumber);
    body.append("isBankDetailsShown", values.isBankDetailsShown);
    body.append("paymentGateway", values.paymentGateway);
    body.append("systemAlerts", values.systemAlerts);
    return await axios.post(`${Config.apiUrl}/editowner`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onEditEntrySuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Success");
      // getOwnersMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setEditUser(false);
    setFetchData(data?.data?.data);
  };
  const onEditEntryError = (data) => {
    setSelectedData("");
    setEditUser(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };
  const { isLoading: editEntryLoading, mutate: editOwnerMutate } = useMutation(
    EditOwnerFunction,
    {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    },
  );
  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("Inactive Owners")}</Title>
              <Underline />
            </div>
          </div>
          <SideModal
            isOpen={isFilterOpen}
            onClose={() => setIsFilterOpen(false)}
          >
            <FilterModal
              handleClose={() => setIsFilterOpen(false)}
              onApplyFilter={(value) => {
                setAdvancedFilter(value);
                setIsFilterOpen(false);
              }}
              handleClearFilters={() => {
                setAdvancedFilter("");
              }}
              currentFilter={{ value: advancedFilter }}
            />
          </SideModal>

          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoadings}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              filter={filter}
              user={user}
              setIsFilterOpen={setIsFilterOpen}
              setAdvancedFilter={setAdvancedFilter}
              t={t}
            />
          </div>

          {editUser && (
            <EditOwnerModel
              editOwnerMutate={editOwnerMutate}
              editEntryLoading={editEntryLoading}
              setEditUser={setEditUser}
              data={data?.data}
              selectedData={selectedData}
            />
          )}

          {viewDetail && (
            <ViewDetailModel
              setViewDetail={setViewDetail}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
            />
          )}
          {!error && !isLoadings && data && (
            <TableWrapper>
              <Table
                ApiData={fetchData || []}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setEditUser={setEditUser}
                setViewDetail={setViewDetail}
                userType={user.userType}
              />
              {(error || data?.data?.msg === "No inactive owners found") && !isLoadings && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoadings || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  filter,
  setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  setIsFilterOpen,
  setAdvancedFilter,
  t,
}) => {
  const today = moment().format("YYYY-MM-DD");
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            {/* <div className="flex items-end gap-2">
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn> */}
          </div>
          <div className="flex gap-3 items-end flex-wrap">
            {filter !== "status" && filter !== "paymentMode" ? (
              <InputGroup className="w-[200px]">
                <Field
                  className="border border-gray-300 rounded-md px-3 h-10 w-full focus:ring-1 focus:ring-primary-color focus:border-primary-color"
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  inputMode={filter === "mobile" ? "numeric" : "text"}
                  maxLength={filter === "mobile" ? "10" : undefined}
                  pattern={filter === "mobile" ? "[0-9]*" : undefined}
                  value={filterValue}
                  onChange={(e) => {
                    if (filter === "mobile" || filter === "id") {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        ChangeHandler(e);
                      }
                    } else {
                      ChangeHandler(e);
                    }
                  }}
                />
              </InputGroup>
            ) : filter === "status" ? (
              <InputGroup className="w-[120px]">
                <Select
                  autoComplete="off"
                  value={filterValue}
                  onChange={ChangeHandler}
                  displayEmpty
                  className="h-10 w-full px-2"
                >
                  <MenuItem value="" disabled>
                    {t("Select Status")}
                  </MenuItem>
                  <MenuItem value="3">{t("Active")}</MenuItem>
                  <MenuItem value="4">{t("Enrolled")}</MenuItem>
                  <MenuItem value="5">{t("Defaulter")}</MenuItem>
                </Select>
              </InputGroup>
            ) : null}

            <InputGroup className="" style={{ flexBasis: "content" }}>
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  setFilterValue("");
                  setAdvancedFilter("");
                }}
              >
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="mobile">Phone</MenuItem>
                {/* <MenuItem value="status">Status</MenuItem> */}
                {/* <MenuItem value="id">ID</MenuItem> */}
                {/* {user.userType !== Config.userType.OPERATION && (
                  <MenuItem value="city">City</MenuItem>
                )} */}
              </Select>
            </InputGroup>

            {/* <button
              type="button"
              onClick={() => setIsFilterOpen(true)}
              className="h-10 w-10 flex items-center justify-center border border-gray-300 rounded-md bg-white hover:bg-gray-100"
            >
              <IoFilter size={18} />
            </button> */}
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;
export default NewOwners;
